// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
import { GlyphNote } from './glyphnote';
import { Glyphs } from './glyphs';
import { Category } from './typeguard';
// Map `type` to SMuFL glyph code.
const CODES = {
    '1': Glyphs.repeat1Bar,
    '2': Glyphs.repeat2Bars,
    '4': Glyphs.repeat4Bars,
    slash: Glyphs.repeatBarSlash,
};
export class RepeatNote extends GlyphNote {
    static get CATEGORY() {
        return Category.RepeatNote;
    }
    constructor(type, noteStruct, options) {
        const glyphCode = CODES[type] || '\uE500'; /*repeat1Bar*/
        super(glyphCode, Object.assign({ duration: 'q', alignCenter: type !== 'slash' }, noteStruct), options);
    }
}
